module.exports = "/_next/static/images/JavaScriptMeetup-55428b4797f0367645e16614a5a17ad8.jpg";